import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { DocumentAccessCredentialsModel } from '@data-layer/models/documents';

@Injectable({
  providedIn: 'root',
})
export class OrganizationLogoRepository {
  constructor(private apiService: ApiService) {}

  public getCredentials(organizationId: number, isShowLoader: boolean = false): Observable<DocumentAccessCredentialsModel> {
    return this.apiService.get<DocumentAccessCredentialsModel>(
      `${environment.url.organizations}${organizationId}/logo/upload-credentials`,
      null,
      {
        isShowLoader,
      },
    );
  }

  public setUrl(organizationId: number, uri: string, isShowLoader: boolean = false): Observable<DocumentAccessCredentialsModel> {
    return this.apiService.put<DocumentAccessCredentialsModel>(
      `${environment.url.organizations}${organizationId}/logo-url`,
      JSON.stringify(uri),
      null,
      {
        isShowLoader,
      },
    );
  }

  public deleteUrl(organizationId: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.delete(`${environment.url.organizations}${organizationId}/logo-url`, null, { isShowLoader });
  }
}
